/*
 * @Description: 文件内容
 * @Author: 陈威达
 * @Date: 2022-10-24 13:15:38
 * @LastEditors: 陈威达
 * @LastEditTime: 2022-11-03 09:42:10
 */
import styles from './login-qr.scss'
import wechatImg from '@/common/images/icon/wechat.png'
import QRCode from 'qrcodejs2'
import { SYSCON } from '@/const/const'
import User from '@/modules/user'
import { useEffect, useState, useRef } from 'react'
import { message } from 'antd'
import { SyncOutlined } from '@ant-design/icons'
const LoginQr = (props) => {
  const scanTimer = useRef(null)
  let maxCount = 0
  const interval = 5000
  const user = new User()
  const [showRefresh, setShowRefresh] = useState(false)
  const [qrcoder, setQrCoder] = useState(null)
  const qrCodeRef = useRef(null)
  useEffect(() => {
    console.log('useEffect')
    getMaxCount()
    init()
    return function() {
      console.log('unmounted')
      clearTimer()
    }
  }, [])
  const handleRefresh = () => {
    setShowRefresh(false)
    getMaxCount()
    init()
  }
  const init = () => {
    console.log('init')
    let scene = ''
    return getQrCode()
      .then((data) => {
        scene = data.scene
        return generateImg(data.qrCodeUrl)
      })
      .then(() => {
        getScanRes(scene)
      })
      .catch(err => {
        console.log(err)
        // this.$emit('has-error')
      })
  }
  const getMaxCount = () => {
    const expire = 1 * 60 * 1000 // 暂定一分钟失效
    maxCount = expire / interval
    console.log(maxCount)
  }
  const getQrCode = () => {
    return user.getWxLoginQrCode()
      .then(data => {
        if (!data) {
          return Promise.reject('empty qrCode')
        }
        return {
          qrCodeUrl: data.qrCodeUrl || '',
          scene: data.scene || ''
        }
      })
  }
  const generateImg = async(qrCodeUrl) => {
    if (!qrCodeUrl) return Promise.reject('empty qrCode')
    if (!qrCodeRef.current) {
      return Promise.reject('qrcode container not found')
    }
    if (qrcoder) {
      console.log({ qrcoder })
      qrcoder.makeCode(qrCodeUrl)
      return
    }
    const coder = new QRCode(qrCodeRef.current, {
      text: qrCodeUrl, // 需要转换为二维码的内容
      width: 200,
      height: 200,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
    setQrCoder(coder)
  }
  const getScanRes = (scene) => {
    clearTimer()
    let count = 0
    scanTimer.current = setInterval(() => {
      count++
      if (count > maxCount) {
        message.warning('二维码已失效，请重新获取')
        clearTimer()
        setShowRefresh(true)
        return
      }
      user.getQrScanRes({ appCatCd: SYSCON.PlatAppWorkbench, scene: scene })
        .then(res => {
        /**
         * 轮询结果说明：
         * 1、 unionid 不为空且 isRegistered 为false 弹出 绑定窗口
         * 2、isRegistered 为true 直接登录（查询根企业列表）
         * 3、unionid 为空继续轮询接口
         */
          if (res && res.status === 210) {
            console.log(210)
            clearTimer()
            return
          }
          if (res && res.unionId) {
            props.getScanRes(res)
          }
        })
        .catch(err => {
          console.log(err)
          // this.$emit('has-error')
          clearTimer()
        })
    }, interval)
  }
  const clearTimer = () => {
    clearInterval(scanTimer.current)
  }
  return (
    <div className={styles['qr-wrapper']}>
      {
        showRefresh && (
          <div className={styles['refresh-box']} onClick={() => handleRefresh()}>
            <span className={styles['refresh-text']}>二维码已过期</span>
            <SyncOutlined style={{ fontSize: '40px' }}/>
            {/* <i class='el-icon-refresh-left' ></i> */}
          </div>
        )
      }
      <div ref={qrCodeRef} className={styles['qrcode']}/>
      <div className={styles['scan-tip']}>
        <p>
          <img src={wechatImg} alt=''/>
          微信扫码
          <span style={{ color: '#45B449', fontWeight: 'bold' }}>关注公众号</span>
        </p>
        <p style={{ paddingLeft: '25px' }}>登录更快更安全</p>
      </div>
    </div>
  )
}

export default LoginQr
